import { BrowserRouter } from "react-router-dom";
import AuditorRouter from "./routers";
import { Provider } from "react-redux";
import { createAppStore } from "./store";
import { App } from "antd";
import "./App.scss";

function AuditorApp() {
  return (
    <App className="d-flex flex-column w-100 h-100 overflow-hide">
      <Provider store={createAppStore()}>
        <BrowserRouter>
          <AuditorRouter />
        </BrowserRouter>
      </Provider>
    </App>
  );
}

export default AuditorApp;
